import React, { useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { apiOrganization } from "../../../../../../../../../services/Api/Organization/apiOrganization";
import { ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";
import { AppState } from "../../../utils/types";
import { parseApplicationSettings, parseApplicationSettingsValues } from "../../../utils/utils";

interface Props {
	appState: AppState;
	handleUpdateApp: (data: ApplicationApi) => void;
}

const GoZoneFormModalCard = ({ appState, handleUpdateApp }: Props) => {
	const { t } = useTranslation();
	const form = useForm<ApplicationApi>({
		criteriaMode: "all",
		defaultValues: {
			...appState.app,
			settings: {
				...appState.app.settings,
				...parseApplicationSettingsValues(appState.app.settings || {}),
			},
		},
	});
	const {
		formState,
		handleSubmit,
		formState: { errors },
		register,
		reset,
		setError,
	} = form;
	const { addSuccessFlash, addFlash } = useFlash();
	const [loading, setLoading] = useState<boolean>(false);

	const getParsedFormData = (data: ApplicationApi) => {
		const settings = parseApplicationSettings(data.settings);
		return {
			name: data.name,
			id: appState.app.id,
			settings,
		};
	};

	const onSubmit = handleSubmit(async (data: ApplicationApi) => {
		setLoading(true);
		try {
			const res = await apiOrganization.updateApp(getParsedFormData(data), { include: "settings" });
			handleUpdateApp(res);
			addSuccessFlash(t("lib:common.flash.saved"));
			reset({
				...res,
				settings: parseApplicationSettingsValues(res.settings),
			});
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<Card>
			<Card.Body>
				<FormDirty formState={formState} onSubmit={onSubmit}>
					<FormInput
						name="settings.code_validation"
						errors={errors}
						register={register}
						label={t("modules.app.field.code_validation.title")}
					/>
					<ButtonLoading loading={loading} variant="add" onClick={onSubmit}>
						{t("lib:common.action.save")}
					</ButtonLoading>
				</FormDirty>
			</Card.Body>
		</Card>
	);
};

export default GoZoneFormModalCard;
